import { useLayoutEffect, useState } from 'react'

import type { StoreReadOnly } from '@subaio/utils'

/**
 * Subscribe to a redux-store-like object, exposing `subscribe` and `getState`.
 */
export const useStore = <T>(store: StoreReadOnly<T>) => {
	const [, setDummyState] = useState({})

	// useLayoutEffect is used instead of useEffect, since useEffect is not run
	// before control is returned by ReactDOM.
	useLayoutEffect(() => store.subscribe(() => setDummyState({})), [store])

	return store.getState()
}
